import cx from 'classnames'

type Props = {
  className?: string
  'data-testid'?: string
}

const Card: React.FC<Props> = ({
  className,
  children,
  'data-testid': dataTestId,
}) => {
  return (
    <div
      className={cx('bg-coolGray-50 p-4 border border-coolGray-300', className)}
      data-testid={dataTestId}
    >
      {children}
    </div>
  )
}

export default Card
